// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b781bf12","107":"e0b7e7e6","434":"6628761e","474":"cabcd42f","658":"f5ba5e91","683":"69e9121e","967":"a55fffb1","990":"289f6b77"}[chunkId] + ".chunk.js";
};